<div class="container h-100 canvas-page">
    <div class="row h-100 justify-content-center align-items-center">
        <div *ngIf="isLoading" class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
        <div class="card SmallForm rounded canvas-panel" *ngIf="isLoading == false"
            [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="card-header MyCardHeader rounded-top">
                <div class="input-group">
                    <div class="form-control MyCardTitle">
                        <h2 class="Head">
                            {{ globalService.Get("SELECTTENANT") }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="card-body MyCardBody rounded-bottom">
                <form #myForm="ngForm" (ngSubmit)="onSubmit(myForm)">
                    <div class="form-group row m-3" [class.text-right]="globalService.isRTL == true">
                        <label for="church" [class.SmallArabicFont]="globalService.isRTL == true">{{
                            globalService.Get("CHURCH_ID") }}</label>
                        <input type="text" id="church" class="form-control text-left" dir="ltr" [(ngModel)]="churchId" name="churchId" list="visited-churches" autocomplete="off"
                            required #churchIdControl="ngModel" />
                        <datalist id="visited-churches"><option *ngFor="let church of recentChurches" [value]="church.id">{{ church.name }}</option></datalist>
                        <div class="recent-churches" *ngIf="recentChurches.length"><h3>{{ globalService.isRTL ? 'كنائس تمت زيارتها' : 'Previously visited' }}</h3><button type="button" *ngFor="let church of recentChurches" class="recent-church" [disabled]="SwitchingChurch" (click)="chooseChurch(church)"><span>{{ church.name }}</span><small>{{ church.id }}</small></button></div>

                        <small class="help-block" *ngIf="!churchIdControl.valid && churchIdControl.touched">{{
                            globalService.Get("CHURCH_ID_REQUIRED")
                            }}</small> 
                    </div>
                    <p class="form-group m-3 text-danger" role="alert" *ngIf="connectionError">{{ globalService.isRTL ? 'تعذر الاتصال. حاول مرة أخرى.' : 'Unable to connect. Please try again.' }}</p>
                    <app-prompt-message class="form-group row m-3" [showForm]="UnknownTenant == true" color="danger" (onClose)="UnknownTenant = false"
                       message="Unrecognized Church ID">
                    </app-prompt-message>                    
                    <div class="form-group m-3" [class.SmallArabicFont]="globalService.isRTL == true">
                        <div class="row">
                          <div class="col-12">
                            <button class="btn btn-primary btn-block" type="submit" [disabled]="SwitchingChurch || !myForm.valid">
                                <i *ngIf="SwitchingChurch == true" class="fas fa-spinner fa-spin"></i>
                              {{ globalService.Get("OPEN_CHURCH") }}
                            </button>
                          </div> 
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>